<template>
  <div id="gradebook">
    <div class="flex flex-wrap">
      <div class="flex mb-4 items-center">
        <span class="font-semibold lg:w-auto w-32">حدد المجموعة</span>
        <vs-select v-model="courseGroup" class="ml-4 vs-input-shadow-drop vs-select-no-border d-theme-input-dark-bg w-48">
          <vs-select-item v-for="(group, index) in getCourseDetails.groups" :key="index"
                          :value="group.group" :text="group.group" />
        </vs-select>
      </div>
      <div class="flex mb-4 items-center lg:ml-4 ml-0">
        <span class="font-semibold lg:w-auto w-32">عرض</span>
        <vs-select v-model="view" class="ml-4 vs-input-shadow-drop vs-select-no-border d-theme-input-dark-bg w-48">
          <vs-select-item v-for="(type, index) in Object.keys(viewTypes)" :key="index"
                          :value="type" :text="viewTypes[type]" />
        </vs-select>
      </div>
    </div>
    <vx-card class="mt-5">
      <div class="flex flex-wrap justify-between items-center">
        <vs-input v-model.trim="search" placeholder="بحث..." icon-pack="feather" icon="icon-search"/>
        <vs-button class="lg:mt-0 mt-4" @click="exportToExcel">إستخراج xlsx</vs-button>
      </div>
      <vs-table hover-flat searchable no-data-text="لا يوجد طلبة" :data="viewStudents">
        <template slot="thead">
          <vs-th sort-key="id">رقم القيد</vs-th>
          <vs-th sort-key="full_name">اسم الطالب</vs-th>
          <template v-if="view !== 'sum'">
            <vs-th v-for="(grade, index) in viewGrades" :key="index">
              <div class="text-left">
                <span class="block text-dark leading-none">{{grade.title}}</span>
                <span class="leading-none">({{grade.type === 'quiz' ? 'إختبار' : 'واجب'}})</span>
              </div>
            </vs-th>
          </template>
          <template v-else>
            <vs-th>مجموع الإختبارات</vs-th>
            <vs-th>مجموع الواجبات</vs-th>
          </template>
          <vs-th>المجموع</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr v-for="(student, index) in data" :key="index">
            <vs-td :data="student.id">{{ student.id }}</vs-td>
            <vs-td>{{ student.full_name }}</vs-td>
            <template v-if="view !== 'sum'">
              <vs-td v-for="(grade, index) in viewGrades" :key="`${index}-${student.id}`">
                <template v-if="grade.student_marks.hasOwnProperty(student.id)">
                  <span class="text-xl">{{grade.student_marks[student.id].mark}}/</span>
                  <span>{{grade.type === 'quiz' ? grade.total_mark[grade.student_marks[student.id].form] : grade.total_mark}}</span>
                </template>
                <template v-else-if="grade.type === 'quiz'">
                  <span class="text-xl">-</span>
                </template>
                <template v-else>
                  <span class="text-xl">0/</span>
                  <span>{{grade.total_mark}}</span>
                </template>
              </vs-td>
            </template>
            <template v-else>
              <vs-td class="text-lg">{{totalGrade(student.id, 'quiz')}}</vs-td>
              <vs-td class="text-lg">{{totalGrade(student.id, 'assignment')}}</vs-td>
            </template>
            <vs-td class="text-lg">{{totalGrade(student.id)}}</vs-td>
          </vs-tr>
        </template>

      </vs-table>
    </vx-card>
  </div>
</template>

<script>
    // TODO remove import store later
    import store from '@/store/store'
    import courseStudentsAPI from '@/api/courseStudentsAPI'

    export default {
        name: "Gradebook",
        data() {
            return {
                search: '',
                students: [],
                courseGroup: 0,
                view: 'both',
                viewTypes: {both: 'الكل', assignment: 'الواجبات', quiz: 'الإختبارات', sum: 'المجموع فقط'},
                grades: {assignments: [], quizzes: []},
            }
        },
        computed: {
            viewStudents(){
                let students = this.students[this.courseGroup]
                if(students)
                    return students.filter(student => {
                        return Object.values(student).toString().indexOf(this.search) !== -1
                    })
            },
            viewGrades() {
                return this.grades.assignments.concat(this.grades.quizzes)
                    .filter(grade => {
                        return (this.view === 'both' || this.view === 'sum' ? true : grade.type === this.view) && grade.groups.includes(this.courseGroup)
                    }).sort((first, second) => {
                        return new Date(first.date) - new Date(second.date)
                    })
            },
            totalGrade() {
                return (studentId, type = null) => {
                    let fullGrade = 0
                    let totalGrade = 0
                    this.viewGrades.forEach(grade => {
                        if(!type || type === grade.type){
                            fullGrade += grade.type !== 'quiz' && grade.total_mark
                            if(grade.student_marks.hasOwnProperty(studentId)){
                                fullGrade += grade.type === 'quiz' && grade.total_mark[grade.student_marks[studentId].form]
                                totalGrade += grade.student_marks[studentId].mark
                            }
                        }
                    })
                    return `${totalGrade}/${fullGrade}`
                }
            }
        },
        methods: {
            getStudentGrade(grade, student_id) {
                if(grade.student_marks.hasOwnProperty(student_id)) {
                    const studentMark = grade.student_marks[student_id].mark
                    const totalMark = grade.type === 'quiz' ? grade.total_mark[grade.student_marks[student_id].form] : grade.total_mark

                    return `${studentMark}/${totalMark}`
                } else if (grade.type === 'quiz'){
                    return '-'
                } else {
                    return `0/${grade.total_mark}`
                }
            },
            exportToExcel() {
                const headerTitle = this.viewGrades.map(grade => grade.title)
                headerTitle.unshift('إسم الطالب')
                headerTitle.unshift('رقم القيد')
                headerTitle.push('المجموع')

                const headerVal = this.viewGrades.map(grade => grade.title)
                headerVal.unshift('name')
                headerVal.unshift('id')
                headerVal.push('total')

                const list = this.viewStudents.map(student => {
                    let student_grades = { id: student.id, name: student.full_name, total: this.totalGrade(student.id) }
                    this.viewGrades.forEach(grade => student_grades[grade.title] = this.getStudentGrade(grade, student.id))
                    return student_grades
                })

                import('@/vendor/Export2Excel').then(excel => {
                    const data = list.map(value => headerVal.map(key => value[key]))
                    excel.export_json_to_excel({
                        header: headerTitle,
                        data,
                        filename: `درجات الطلبة في (${this.getCourseDetails.name} ${this.courseGroup})`,
                        desc: `درجات الطلبة في (${this.getCourseDetails.name} ${this.courseGroup})`
                    })
                })

            }
        },
        beforeRouteEnter(to, from, next){
            store.dispatch('studentsCourse/loadStudents', to.params.course_id)
                .then(students => {
                    courseStudentsAPI.setCourseId(to.params.course_id)
                    courseStudentsAPI.grades().then(({data}) => {
                        next(vm => {
                            vm.students = students
                            vm.courseGroup = Object.keys(vm.students)[0]
                            vm.grades = data
                        })
                    })
                })
                .catch(error => {if(error.status === 403) next('/not-found-404')})
        },
    }
</script>
